import type { JSX } from 'react';
import { VerifiedSeal } from './VerifiedSeal';

export interface CertificateTitleProps {
  candidateName: string;
}

/**
 * Formal title block of the certificate: seal, document type, holder.
 */
export function CertificateTitle({ candidateName }: CertificateTitleProps): JSX.Element {
  return (
    <div className="flex flex-col items-center gap-4 text-center">
      <VerifiedSeal />
      <p className="text-[0.7rem] font-semibold uppercase tracking-[0.3em] text-muted-foreground">
        Experience Confirmation Certificate
      </p>
      <h1 className="font-serif text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
        {candidateName}
      </h1>
    </div>
  );
}
